import { render, staticRenderFns } from "./_certification.vue?vue&type=template&id=400852b6"
import script from "./_certification.vue?vue&type=script&lang=js"
export * from "./_certification.vue?vue&type=script&lang=js"
import style0 from "./_certification.vue?vue&type=style&index=0&id=400852b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports